import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ActionWrapperClass;
function ActionWrapper() {
  if (ActionWrapperClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ActionWrapper');
    ActionWrapperClass = $;
  }
  return ActionWrapperClass;
}
//region block: exports
export {
  ActionWrapper as ActionWrapper2ie29abg6ehro,
};
//endregion

//# sourceMappingURL=ActionWrapper.mjs.map
